module.exports = __webpack_public_path__ + "media/images/teste-4bf3555cad81ce685dba314f5bff95e7.jpg";